$(document).ready(function(){
  $('.btn.site-nav__thumb-button').on('click', function(){
  	$('.mobile-bg').toggleClass('visible');
    $('body').toggleClass('nav-open');
  });
  $('.mobile-bg').on('click', function(){
  	$('.btn.site-nav__thumb-button').trigger('click');
  });
  $('.nav-close').on('click', function(){
  	$('.btn.site-nav__thumb-button').trigger('click');
  });
  
  $(window).scroll(function(){
    var aTop = $('.site-header').height();
    if($(this).scrollTop()>=aTop){
        $('.header-section-wrapper').addClass('header--sticky');
        // instead of alert you can use to show your ad
        // something like $('#footAd').slideup();
    }else{
    	$('.header-section-wrapper').removeClass('header--sticky');
    }
  });
  
  $(document).on("swell:initialized", function() {
    // Do code after 1s
    setTimeout (function() {
      // Call the Earning Points section
      var a = document.querySelector('[yotpo-instance-id="61615"]');
      // Call the Newsletter and SMS Signup by calling the CustomActionCampaign attributes
      var b = a.querySelectorAll('[aria-label="CustomActionCampaign"]');
      // Store the grids in a variable
      var email_signup = b[0];
      var sms_signup = b[1];
      // Add the onclick attributes for sms_signup and email_signup
      email_signup.setAttribute('onclick', 'window.open("https://noleo.attn.tv/p/Y9Z/landing-page", "_blank")');
      sms_signup.setAttribute('onclick', 'window.open("https://noleo.attn.tv/p/Y9Z/landing-page", "_blank")');
    }, 1000);  
  });
  
});

